import type { FunctionComponent } from 'react'
import React from 'react'
import { DateTime, ReadingTime } from '@which/seatbelt'

export const PIArticleDate: FunctionComponent<Props> = ({ estimatedReadingTime, date }) => {
  const readTimeText = 'min read'
  const hasReadTime = estimatedReadingTime.includes(readTimeText)
  const readTime = hasReadTime
    ? estimatedReadingTime.replace(readTimeText, '')
    : estimatedReadingTime

  return (
    <div className="mb-4">
      <div className="d-flex align-center">
        <DateTime dateInput={date} showDateOrTime={'Date'} />

        <div className="d-flex align-center ml-3">
          <ReadingTime readTime={readTime} />
        </div>
      </div>
    </div>
  )
}

type Props = {
  date: string
  estimatedReadingTime: string
}
